<template>
  <v-dialog v-model="isLoading" max-width="120" persistent>
    <v-card
      round
      style="width: 120px; background-color: #1a1a1a"
      class="pa-6 ma-0"
      outlined
    >
      <v-progress-circular indeterminate :size="70" width="1" />
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "niko-loader",
  props: ["isLoading"],
};
</script>
